import { NOTIFICATION_ON, NOTIFICATION_OFF, LOAD_PARTY, ADD_PARTY, EDIT_PARTY, ACCESS, TOGGLE_COLLAPSE, GET_MY_DETAILS, GET_MY_LEAVE, GET_MY_LEAVE_BALANCE, GET_HOLIDAY, GET_MY_ATTENDANCE, SOCKET_ON, CHATBOX, GET_MESSAGE, GET_PAYHEAD, GET_EMPLOYEE, LOAD_TASK_COUNTS} from "../constants/action-types";

const initialState = {
    notification_type: '',
    notification_status: '',
    notification_text: '',
    notification_action:false,
    notification_link:'',
    selectedKeys: ['home'],


    collapse: false,
    drawerWidth: 120,

    myDetails: {},
    isMyDetailsLoaded: false,

    leave_balance:[],
    isLeaveBalanceLoaded:false,

    my_attendance:[],
    isAttendanceLoaded:false,

    my_leave:[],
    isMyLeaveLoaded:false,

    holiday:[],
    isHolidayLoaded:false,

    employee: [],
    isEmployeeLoaded: false,

    notice:[],
    isNoticeLoaded:false,

    grievance:[],
    isGrievanceLoaded:false,

    my_grievance:[],
    isMyGrievanceLoaded:false,
    socket: {},
    chatBox:false,
    message:[],
    isMessageLoaded:false,
    payhead: [],
    isPayheadLoaded: false,

    task_counts: { today: 0, upcoming: 0, overdue: 0, done: 0 },
    isTaskCountsLoaded: false,

};
function rootReducer(state = initialState, action) {



    if (action.type === NOTIFICATION_ON) {
        return Object.assign({}, state, {
            notification_type: action.payload.type,
            notification_status: action.payload.status,
            notification_text: action.payload.text,
            notification_action: action.payload.action,
            notification_link: action.payload.link
        });
    }

    if (action.type === NOTIFICATION_OFF) {
        return Object.assign({}, state, {
            notification_type: '',
            notification_status: '',
            notification_text: '',
            notification_action:false,
            notification_link:''
        });
    }


   
    if (action.type === GET_MY_DETAILS) {
        return Object.assign({}, state, {
            myDetails: action.payload,
            isMyDetailsLoaded: true
        });
    }

    if (action.type === GET_MY_ATTENDANCE) {
        return Object.assign({}, state, {
            my_attendance: action.payload,
            isAttendanceLoaded: true
        });
    }


    if (action.type === GET_MY_LEAVE_BALANCE) {
        return Object.assign({}, state, {
            leave_balance: action.payload,
            isLeaveBalanceLoaded: true
        });
    }

    if (action.type === GET_MY_LEAVE) {
        return Object.assign({}, state, {
            my_leave: action.payload,
            isMyLeaveLoaded: true
        });
    }

    if (action.type === GET_HOLIDAY) {
        return Object.assign({}, state, {
            holiday: action.payload,
            isHolidayLoaded: true
        });
    }

    if (action.type === GET_MESSAGE) {
        return Object.assign({}, state, {
            message: action.payload,
            isMessageLoaded: true
        });
    }

     //Payhead
 if (action.type === GET_PAYHEAD) {
        
    return Object.assign({}, state, {
        payhead: action.payload,
        isPayheadLoaded: true
    });
}


    if (action.type === SOCKET_ON) {
        return Object.assign({}, state, {
            socket: action.payload
        });
    }

    //Employee
if (action.type === GET_EMPLOYEE) {

    return Object.assign({}, state, {
        employee: action.payload,
        isEmployeeLoaded: true
    });
}

    // Task tab counts (home dashboard badges)
    if (action.type === LOAD_TASK_COUNTS) {
        const p = action.payload || {};
        return Object.assign({}, state, {
            task_counts: {
                today:    Number(p.today)    || 0,
                upcoming: Number(p.upcoming) || 0,
                overdue:  Number(p.overdue)  || 0,
                done:     Number(p.done)     || 0,
            },
            isTaskCountsLoaded: true,
        });
    }

    if (action.type === CHATBOX) {
        return Object.assign({}, state, {
            chatBox: action.payload
        });
    }

    //do not delete
    if(action.type === TOGGLE_COLLAPSE){
        let dw = 200;
        if(state.collapse){
            dw = 80;
        }else{
            dw = 200
        }

        if(action.payload === null){
            return Object.assign({}, state, {
                collapse: !state.collapse,
                drawerWidth: dw
             });
        }else{
            return Object.assign({}, state, {
                collapse: action.payload,
                drawerWidth: dw
             });
        }
        
    }



    return state;
}
export default rootReducer;